import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';
import { logger } from '@/lib/logger';

export function useOnboardingStatus() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [onboardingCompleted, setOnboardingCompleted] = useState(false);

  useEffect(() => {
    checkOnboardingStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- existing stable pattern
  }, [user, authLoading]);

  const checkOnboardingStatus = async () => {
    if (authLoading) return;

    if (!user) {
      setChecking(false);
      return;
    }

    try {
      // Obtener perfil del usuario
      const { data: profile, error } = await supabase
        .from('profiles')
        .select('user_type, onboarding_completed')
        .eq('id', user.id)
        .single();

      if (error) throw error;

      // Solo verificar onboarding para providers
      if (profile.user_type === 'provider') {
        setOnboardingCompleted(profile.onboarding_completed || false);

        // Si es provider y NO completó onboarding, redirigir
        if (!profile.onboarding_completed && window.location.pathname !== '/onboarding') {
          navigate('/onboarding');
        }
      } else {
        // Los clientes no necesitan onboarding
        setOnboardingCompleted(true);
      }
    } catch (error) {
      logger.error('Error verificando onboarding:', error);
    } finally {
      setChecking(false);
    }
  };

  return {
    onboardingCompleted,
    checking: checking || authLoading,
  };
}
